export default __webpack_public_path__ + "static/media/SettingsActive.7145e941.svg";